import Icon from '../components/Icon.vue'

Icon.register({
  'candy-cane': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.5 92C469.6 33.1 411.8 0 352.4 0 324.5 0 296.2 7.3 270.6 22.6L243.1 39C227.9 48.1 223 67.7 232.1 82.9L264.9 137.8C270.9 147.8 281.5 153.4 292.4 153.4 298 153.4 303.6 151.9 308.8 148.9L336.3 132.5C341.4 129.4 347.1 128 352.7 128 363.6 128 374.2 133.6 380.2 143.6 389.3 158.7 384.3 178.4 369.2 187.5L15.6 397.6C0.4 406.7-4.5 426.3 4.6 441.5L37.4 496.4C43.4 506.4 54 512 64.9 512 70.5 512 76.1 510.5 81.3 507.5L428.6 301C500.3 258.1 533.2 167.5 497.5 92zM319.8 105L317.3 106.5 296.8 45C306.5 40.3 316.6 36.9 327.1 34.8L347.7 96.6C337.9 97.4 328.3 99.9 319.8 105zM145.9 431.8L85.4 393.3 116.2 375 176.7 413.5 145.9 431.8zM253.4 367.9L192.9 329.4 223.7 311.1 284.2 349.6 253.4 367.9zM364.3 302L303.8 263.5 334.6 245.2 395.1 283.7 364.3 302zM384.7 104.7L430.7 58.7C439.1 65.2 446.7 72.8 453.3 81.3L407.6 127C401.9 117.7 393.9 110.1 384.7 104.7zM466.8 212.5L407.3 192.7C410.5 187.4 413.1 181.8 414.7 175.6 415.8 171.1 416.4 166.5 416.5 162L476.9 182.1C474.8 192.5 471.4 202.7 466.8 212.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/candy-cane.js
// module id = 8767
// module chunks = 144